/* globals jQuery */
import { easing, animSpeed } from './_vars.js';
import * as Ladda from 'ladda';

(function(window, document, $) {
	function notificationTimer (element) {
		element.fadeTo(animSpeed, 0, easing, function(){
			$(this).remove();
		});
	}

	$(document).ready(function() {
		var messageTimeout;
		function handleSubmit (form) {
			var notification, generalErrorMessage;
			var appendElement = 'body';
			var timerLength = 5000;
			var laddaButton = form.id === 'feedbackForm' ? Ladda.create($('#feedback-form-submit').get(0)) : Ladda.create($('#contact-form-submit').get(0));
			if (form.id === 'feedbackForm') {
				generalErrorMessage = 'There was an error sending your feedback.<br />Please get in touch with us using the info on our <a href="contact.php">contact page</a>.';
			} else {
				generalErrorMessage = 'There was an error sending your message.<br />Please get in touch with us <a href="mailto:art@imagetransfers.com">by email</a> or phone.';
			}
			laddaButton.start();
			$.ajax({
				type: $(form).attr('method'),
				url: $(form).attr('action'),
				data: $(form).serialize() + '&id=' + form.id,
				dataType: 'json'
			})
			.always(function (response, textStatus, jqXHR) {
				laddaButton.stop();
				$('.notification').remove();
				if (jqXHR.status === 200 && response.success) {
					var successMessage = 'Your message has been sent.<br />We will be in touch shortly.';
					if (form.id === 'feedbackForm') {
						$.fn.closeModal();
						successMessage = 'Your message has been sent.<br />Thank you for your feedback.';
					}
					notification = $('<p class="notification notification-successful">' + successMessage + '<span class="notification-close icon">Close</span></p>');
					messageTimeout = window.setTimeout(function(){
						notificationTimer($('.notification'));
					}, timerLength);
					$('#' + form.id + ' [name="message"], #' + form.id + ' [name="subject"]').val('');
				} else {
					notification = $('<p class="notification notification-error">' + generalErrorMessage + '<span class="notification-close icon">Close</span></p>');
					// console.error(textStatus, jqXHR);
				}
				notification.hide().appendTo(appendElement).fadeTo(animSpeed, 1, easing);
				window.clearTimeout(messageTimeout);
			});
			return false;
		}
		$("#feedbackForm").validate({
			errorElement: "div",
			rules: {
				name: {
					minlength: 2
				},
				email: {
					email: true
				},
				message: {
					minlength: 2
				}
			},
			submitHandler: handleSubmit
		});

		$("#contactForm").validate({
			errorElement: "div",
			rules: {
				name: {
					minlength: 2
				},
				phone: {
					required: false,
					phone: true
				},
				email: {
					email: true
				},
				message: {
					minlength: 2
				},
				subject: {
					minlength: 2
				}
			},
			submitHandler: handleSubmit
		});
	});
}(window, document, jQuery));